import type { ReplaySession } from "./types";
import rustSession from "./rust.json";
import pythonSession from "./python.json";
import goSession from "./go.json";
import elixirSession from "./elixir.json";
import javaSession from "./java.json";
import csharpSession from "./csharp.json";
import cudaSession from "./cuda.json";
import typescriptSession from "./typescript.json";

export const sessions: Record<string, ReplaySession> = {
  rust: rustSession satisfies ReplaySession,
  python: pythonSession satisfies ReplaySession,
  go: goSession satisfies ReplaySession,
  elixir: elixirSession satisfies ReplaySession,
  java: javaSession satisfies ReplaySession,
  csharp: csharpSession satisfies ReplaySession,
  cuda: cudaSession satisfies ReplaySession,
  typescript: typescriptSession satisfies ReplaySession,
};
